import _filter from "lodash/filter";
import _includes from "lodash/includes";
import _isEmpty from "lodash/isEmpty";
import _map from "lodash/map";
import { TFunction } from "i18n";
import { ICountry } from "shared-services/src/services/location";
import { formatListWithMore } from "pages/JobsPage/components/RolePreferences/helpers/formatListWithMore";

export function mapProductionCountries({
  productionCountries,
  countryIds,
  anyProductionCountry,
  t,
}: {
  productionCountries: ICountry[];
  countryIds: string[];
  anyProductionCountry?: boolean;
  t: TFunction;
}): string {
  if (anyProductionCountry) {
    return t(
      "common:jobs.page.rolePreferences.productionCountries.anyDescription"
    );
  }

  if (_isEmpty(productionCountries) || _isEmpty(countryIds)) {
    return "";
  }

  const selectedCountries = _filter(productionCountries, ({ countryCode }) =>
    _includes(countryIds, countryCode)
  );

  const selectedCountryNames = _map(selectedCountries, "localisedCountryName");

  return formatListWithMore(selectedCountryNames, t);
}
